import { doLogout } from "actions/authAction";
import {
  BASE_URL,
  MSTTRAYEK_URL,
  MSTTRAYEK_GET_ERROR,
  MSTTRAYEK_GET_LOADING,
  MSTTRAYEK_GET_SUCCESS,
  MSTTRAYEK_VIEW_ERROR,
  MSTTRAYEK_VIEW_LOADING,
  MSTTRAYEK_VIEW_SUCCESS,
  MSTTRAYEK_ADD_ERROR,
  MSTTRAYEK_ADD_LOADING,
  MSTTRAYEK_ADD_SUCCESS,
  MSTTRAYEK_DELETE_ERROR,
  MSTTRAYEK_DELETE_LOADING,
  MSTTRAYEK_DELETE_SUCCESS,
  LISTTRAYEK_URL,
  MSTTRAYEK_LIST_LOADING,
  MSTTRAYEK_LIST_SUCCESS,
  MSTTRAYEK_LIST_ERROR,
  TRAYEK_MANAGEMENT_QUOTA_LIST_ERROR,
  TRAYEK_MANAGEMENT_QUOTA_LIST_LOADING,
  TRAYEK_MANAGEMENT_QUOTA_LIST_SUCCESS,
  TRAYEK_MANAGEMENT_QUOTA_LIST_URL,
  SCHEDULE_MANAGEMENT_QUOTA_ERROR,
  SCHEDULE_MANAGEMENT_QUOTA_LOADING,
  SCHEDULE_MANAGEMENT_QUOTA_SUCCESS,
  GET_MANAGEMENT_QUOTA_ERROR,
  GET_MANAGEMENT_QUOTA_LOADING,
  GET_MANAGEMENT_QUOTA_SUCCESS,
  UPDATE_MANAGEMENT_QUOTA_ERROR,
  UPDATE_MANAGEMENT_QUOTA_LOADING,
  UPDATE_MANAGEMENT_QUOTA_SUCCESS,
  SCHEDULE_MANAGEMENT_QUOTA_URL,
  GET_MANAGEMENT_QUOTA_URL,
  UPDATE_MANAGEMENT_QUOTA_URL,
  ADD_SHIPPER_ON_TRAYEK_ERROR,
  ADD_SHIPPER_ON_TRAYEK_LOADING,
  ADD_SHIPPER_ON_TRAYEK_SUCCESS,
  REMOVE_SHIPPER_ON_TRAYEK_ERROR,
  REMOVE_SHIPPER_ON_TRAYEK_LOADING,
  REMOVE_SHIPPER_ON_TRAYEK_SUCCESS,
  LIST_SHIPPER_ON_TRAYEK_ERROR,
  LIST_SHIPPER_ON_TRAYEK_LOADING,
  LIST_SHIPPER_ON_TRAYEK_SUCCESS,
  ADD_SHIPPER_ON_TRAYEK_URL,
  REMOVE_SHIPPER_ON_TRAYEK_URL,
  LIST_SHIPPER_ON_TRAYEK_URL,
  MSTTRAYEK_TERPUSAT_GET_SUCCESS,
  MSTTRAYEK_TERPUSAT_GET_ERROR,
  MSTTRAYEK_TERPUSAT_GET_LOADING,
} from "./constant";

const updateManagementQuotaError = (bool) => {
  return {
    type: UPDATE_MANAGEMENT_QUOTA_ERROR,
    updateManagementQuotaError: bool,
  };
};

const updateManagementQuotaLoading = (bool) => {
  return {
    type: UPDATE_MANAGEMENT_QUOTA_LOADING,
    updateManagementQuotaLoading: bool,
  };
};

const updateManagementQuotaSuccess = (bool, updateManagementQuota) => {
  return {
    type: UPDATE_MANAGEMENT_QUOTA_SUCCESS,
    updateManagementQuotaSuccess: bool,
    updateManagementQuota,
  };
};

const getManagementQuotaError = (bool) => {
  return {
    type: GET_MANAGEMENT_QUOTA_ERROR,
    getManagementQuotaError: bool,
  };
};

const getManagementQuotaLoading = (bool) => {
  return {
    type: GET_MANAGEMENT_QUOTA_LOADING,
    getManagementQuotaLoading: bool,
  };
};

const getManagementQuotaSuccess = (bool, getManagementQuota) => {
  return {
    type: GET_MANAGEMENT_QUOTA_SUCCESS,
    getManagementQuotaSuccess: bool,
    getManagementQuota,
  };
};

const scheduleManagementQuotaError = (bool) => {
  return {
    type: SCHEDULE_MANAGEMENT_QUOTA_ERROR,
    scheduleManagementQuotaError: bool,
  };
};

const scheduleManagementQuotaLoading = (bool) => {
  return {
    type: SCHEDULE_MANAGEMENT_QUOTA_LOADING,
    scheduleManagementQuotaLoading: bool,
  };
};

const scheduleManagementQuotaSuccess = (bool, scheduleManagementQuota) => {
  return {
    type: SCHEDULE_MANAGEMENT_QUOTA_SUCCESS,
    scheduleManagementQuotaSuccess: bool,
    scheduleManagementQuota,
  };
};

const trayekManagementQuotaError = (bool) => {
  return {
    type: TRAYEK_MANAGEMENT_QUOTA_LIST_ERROR,
    trayekManagementQuotaError: bool,
  };
};

const trayekManagementQuotaLoading = (bool) => {
  return {
    type: TRAYEK_MANAGEMENT_QUOTA_LIST_LOADING,
    trayekManagementQuotaLoading: bool,
  };
};

const trayekManagementQuotaSuccess = (bool, trayekManagementQuota) => {
  return {
    type: TRAYEK_MANAGEMENT_QUOTA_LIST_SUCCESS,
    trayekManagementQuotaSuccess: bool,
    trayekManagementQuota,
  };
};

const msttrayekGetError = (bool) => {
  return {
    type: MSTTRAYEK_GET_ERROR,
    msttrayekGetError: bool,
  };
};

const msttrayekGetLoading = (bool) => {
  return {
    type: MSTTRAYEK_GET_LOADING,
    msttrayekGetLoading: bool,
  };
};

const msttrayekTerpusatGetSuccess = (bool, msttrayekTerpusats) => {
  return {
    type: MSTTRAYEK_TERPUSAT_GET_SUCCESS,
    msttrayekGetSuccess: bool,
    msttrayekTerpusats,
  };
};

const msttrayekTerpusatGetError = (bool) => {
  return {
    type: MSTTRAYEK_TERPUSAT_GET_ERROR,
    msttrayekGetError: bool,
  };
};

const msttrayekTerpusatGetLoading = (bool) => {
  return {
    type: MSTTRAYEK_TERPUSAT_GET_LOADING,
    msttrayekGetLoading: bool,
  };
};

const msttrayekGetSuccess = (bool, msttrayeks) => {
  return {
    type: MSTTRAYEK_GET_SUCCESS,
    msttrayekGetSuccess: bool,
    msttrayeks,
  };
};

const msttrayekListError = (bool) => {
  return {
    type: MSTTRAYEK_LIST_ERROR,
    msttrayekListError: bool,
  };
};

const msttrayekListLoading = (bool) => {
  return {
    type: MSTTRAYEK_LIST_LOADING,
    msttrayekListLoading: bool,
  };
};

const msttrayekListSuccess = (bool, listtrayeks) => {
  return {
    type: MSTTRAYEK_LIST_SUCCESS,
    msttrayekListSuccess: bool,
    listtrayeks,
  };
};

const msttrayekViewError = (bool) => {
  return {
    type: MSTTRAYEK_VIEW_ERROR,
    msttrayekViewError: bool,
  };
};

const msttrayekViewLoading = (bool) => {
  return {
    type: MSTTRAYEK_VIEW_LOADING,
    msttrayekViewLoading: bool,
  };
};

const msttrayekViewSuccess = (bool, msttrayek) => {
  return {
    type: MSTTRAYEK_VIEW_SUCCESS,
    msttrayekViewSuccess: bool,
    msttrayek,
  };
};

const msttrayekAddError = (bool) => {
  return {
    type: MSTTRAYEK_ADD_ERROR,
    msttrayekAddError: bool,
  };
};

const msttrayekAddLoading = (bool) => {
  return {
    type: MSTTRAYEK_ADD_LOADING,
    msttrayekAddLoading: bool,
  };
};

const msttrayekAddSuccess = (bool, msttrayek) => {
  return {
    type: MSTTRAYEK_ADD_SUCCESS,
    msttrayekAddSuccess: bool,
    msttrayek,
  };
};

const msttrayekDeleteError = (bool) => {
  return {
    type: MSTTRAYEK_DELETE_ERROR,
    msttrayekDeleteError: bool,
  };
};

const msttrayekDeleteLoading = (bool) => {
  return {
    type: MSTTRAYEK_DELETE_LOADING,
    msttrayekDeleteLoading: bool,
  };
};

const msttrayekDeleteSuccess = (bool, msttrayek) => {
  return {
    type: MSTTRAYEK_DELETE_SUCCESS,
    msttrayekDeleteSuccess: bool,
    msttrayek,
  };
};

const msttrayekAddShipperError = (bool) => {
  return {
    type: ADD_SHIPPER_ON_TRAYEK_ERROR,
    msttrayekAddShipperError: bool,
  };
};

const msttrayekAddShipperLoading = (bool) => {
  return {
    type: ADD_SHIPPER_ON_TRAYEK_LOADING,
    msttrayekAddShipperLoading: bool,
  };
};

const msttrayekAddShipperSuccess = (bool, msttrayekAddShipper) => {
  return {
    type: ADD_SHIPPER_ON_TRAYEK_SUCCESS,
    msttrayekAddShipperSuccess: bool,
    msttrayekAddShipper,
  };
};

const msttrayekRemoveShipperError = (bool) => {
  return {
    type: REMOVE_SHIPPER_ON_TRAYEK_ERROR,
    msttrayekRemoveShipperError: bool,
  };
};

const msttrayekRemoveShipperLoading = (bool) => {
  return {
    type: REMOVE_SHIPPER_ON_TRAYEK_LOADING,
    msttrayekRemoveShipperLoading: bool,
  };
};

const msttrayekRemoveShipperSuccess = (bool, msttrayekRemoveShipper) => {
  return {
    type: REMOVE_SHIPPER_ON_TRAYEK_SUCCESS,
    msttrayekRemoveShipperSuccess: bool,
    msttrayekRemoveShipper,
  };
};

const msttrayekListShipperError = (bool) => {
  return {
    type: LIST_SHIPPER_ON_TRAYEK_ERROR,
    msttrayekListShipperError: bool,
  };
};

const msttrayekListShipperLoading = (bool) => {
  return {
    type: LIST_SHIPPER_ON_TRAYEK_LOADING,
    msttrayekListShipperLoading: bool,
  };
};

const msttrayekListShipperSuccess = (bool, msttrayekListShipper) => {
  return {
    type: LIST_SHIPPER_ON_TRAYEK_SUCCESS,
    msttrayekListShipperSuccess: bool,
    msttrayekListShipper,
  };
};

export function msttrayekAddShipper(data) {
  return (dispatch) => {
    dispatch(msttrayekAddShipperError(false));
    dispatch(msttrayekAddShipperSuccess(false, null));
    dispatch(msttrayekAddShipperLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(BASE_URL + ADD_SHIPPER_ON_TRAYEK_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(msttrayekAddShipperLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((msttrayek) => {
        if (msttrayek.status === 200) {
          dispatch(msttrayekAddShipperSuccess(true, msttrayek));
        } else {
          dispatch(msttrayekAddShipperError(true));
        }
      })
      .catch((err) => {
        dispatch(msttrayekAddShipperError(true));
      });
  };
}

export function msttrayekRemoveShipper(data) {
  return (dispatch) => {
    dispatch(msttrayekRemoveShipperError(false));
    dispatch(msttrayekRemoveShipperSuccess(false, null));
    dispatch(msttrayekRemoveShipperLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(BASE_URL + REMOVE_SHIPPER_ON_TRAYEK_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(msttrayekRemoveShipperLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((msttrayek) => {
        if (msttrayek.status === 200) {
          dispatch(msttrayekRemoveShipperSuccess(true, msttrayek));
        } else {
          dispatch(msttrayekRemoveShipperError(true));
        }
      })
      .catch((err) => {
        dispatch(msttrayekRemoveShipperError(true));
      });
  };
}

export function msttrayekListShipper(data) {
  return (dispatch) => {
    dispatch(msttrayekListShipperError(false));
    dispatch(msttrayekListShipperSuccess(false, null));
    dispatch(msttrayekListShipperLoading(true));
    dispatch(msttrayekRemoveShipperSuccess(false, null));
    dispatch(msttrayekAddShipperSuccess(false, null));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(BASE_URL + LIST_SHIPPER_ON_TRAYEK_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(msttrayekListShipperLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((msttrayek) => {
        if (msttrayek.status === 200) {
          dispatch(msttrayekListShipperSuccess(true, msttrayek));
        } else {
          dispatch(msttrayekListShipperError(true));
        }
      })
      .catch((err) => {
        dispatch(msttrayekListShipperError(true));
      });
  };
}

export function listTrayekManagementQuotaFetchAll(params) {
  return (dispatch) => {
    // dispatch(msttrayekAddSuccess(false, null));
    dispatch(trayekManagementQuotaSuccess(false, null));
    dispatch(trayekManagementQuotaError(false));
    dispatch(trayekManagementQuotaLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + TRAYEK_MANAGEMENT_QUOTA_LIST_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(trayekManagementQuotaLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(trayekManagementQuotaSuccess(true, data));
      })
      .catch((err) => {
        dispatch(trayekManagementQuotaError(true));
      });
  };
}

export function scheduleManagementQuotaFetch(params) {
  return (dispatch) => {
    // dispatch(msttrayekAddSuccess(false, null));
    dispatch(scheduleManagementQuotaSuccess(false, null));
    dispatch(scheduleManagementQuotaError(false));
    dispatch(scheduleManagementQuotaLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_MANAGEMENT_QUOTA_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleManagementQuotaLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleManagementQuotaSuccess(true, data));
      })
      .catch((err) => {
        dispatch(scheduleManagementQuotaError(true));
      });
  };
}

export function fetchManagementQuota(params) {
  return (dispatch) => {
    // dispatch(msttrayekAddSuccess(false, null));
    dispatch(getManagementQuotaSuccess(false, null));
    dispatch(getManagementQuotaError(false));
    dispatch(getManagementQuotaLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + GET_MANAGEMENT_QUOTA_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(getManagementQuotaLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(getManagementQuotaSuccess(true, data));
      })
      .catch((err) => {
        dispatch(getManagementQuotaError(true));
      });
  };
}

export function updateTrayekManagementQuota(params) {
  return (dispatch) => {
    // dispatch(msttrayekAddSuccess(false, null));
    dispatch(updateManagementQuotaSuccess(false, null));
    dispatch(updateManagementQuotaError(false));
    dispatch(updateManagementQuotaLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + UPDATE_MANAGEMENT_QUOTA_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(updateManagementQuotaLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(updateManagementQuotaSuccess(true, data));
      })
      .catch((err) => {
        dispatch(updateManagementQuotaError(true));
      });
  };
}

export function listTrayekFetchAll(params) {
  return (dispatch) => {
    dispatch(msttrayekAddSuccess(false, null));
    dispatch(msttrayekListSuccess(false, null));
    dispatch(msttrayekListError(false));
    dispatch(msttrayekListLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + LISTTRAYEK_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(msttrayekListLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(msttrayekListSuccess(true, data));
      })
      .catch((err) => {
        dispatch(msttrayekListError(true));
      });
  };
}

export function msttrayekFetchAll(params) {
  return (dispatch) => {
    dispatch(msttrayekAddSuccess(false, null));
    dispatch(msttrayekGetSuccess(false, null));
    dispatch(msttrayekGetError(false));
    dispatch(msttrayekGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + MSTTRAYEK_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(msttrayekGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(msttrayekGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(msttrayekGetError(true));
      });
  };
}

export function msttrayekTerpusat(params) {
  return (dispatch) => {
    // dispatch(msttrayekAddSuccess(false, null));
    dispatch(msttrayekTerpusatGetSuccess(false, null));
    dispatch(msttrayekTerpusatGetError(false));
    dispatch(msttrayekTerpusatGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "jadwal-terpusat/trayek-list", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(msttrayekTerpusatGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(msttrayekTerpusatGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(msttrayekTerpusatGetError(true));
      });
  };
}

export function msttrayekFetchSub(path) {
  return (dispatch) => {
    dispatch(msttrayekAddSuccess(false, null));
    dispatch(msttrayekGetSuccess(false, null));
    dispatch(msttrayekGetError(false));
    dispatch(msttrayekGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + MSTTRAYEK_URL + "/" + path, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(msttrayekGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(msttrayekGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(msttrayekGetError(true));
      });
  };
}

export function msttrayekFetchPage(params) {
  return (dispatch) => {
    dispatch(msttrayekAddSuccess(false, null));
    dispatch(msttrayekGetSuccess(false, null));
    dispatch(msttrayekGetError(false));
    dispatch(msttrayekGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + MSTTRAYEK_URL + "/page", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(msttrayekGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(msttrayekGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(msttrayekGetError(true));
      });
  };
}

export function msttrayekAdd(data) {
  return (dispatch) => {
    dispatch(msttrayekAddError(false));
    dispatch(msttrayekAddSuccess(false, null));
    dispatch(msttrayekAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(BASE_URL + MSTTRAYEK_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(msttrayekAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((msttrayek) => {
        if (msttrayek.success) {
          dispatch(msttrayekAddSuccess(true, msttrayek.data));
        } else {
          dispatch(msttrayekAddError(true));
        }
      })
      .catch((err) => {
        dispatch(msttrayekAddError(true));
      });
  };
}

export function msttrayekFetchOne(id) {
  return (dispatch) => {
    dispatch(msttrayekAddSuccess(false, null));
    dispatch(msttrayekViewError(false));
    dispatch(msttrayekViewSuccess(false, null));
    dispatch(msttrayekViewLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + MSTTRAYEK_URL + "/" + id, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(msttrayekViewLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(msttrayekViewSuccess(true, data));
      })
      .catch((err) => {
        dispatch(msttrayekViewError(true));
      });
  };
}

export function msttrayekUpdate(data) {
  return (dispatch) => {
    dispatch(msttrayekAddError(false));
    dispatch(msttrayekAddSuccess(false, null));
    dispatch(msttrayekAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + MSTTRAYEK_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(msttrayekAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((msttrayek) => {
        if (msttrayek.success) {
          dispatch(msttrayekAddSuccess(true, msttrayek));
        } else {
          dispatch(msttrayekAddError(true));
        }
      })
      .catch((err) => {
        dispatch(msttrayekAddError(true));
      });
  };
}

export function msttrayekDelete(dataPost) {
  return (dispatch) => {
    dispatch(msttrayekGetSuccess(false, null));
    dispatch(msttrayekDeleteError(false));
    dispatch(msttrayekDeleteSuccess(false, null));
    dispatch(msttrayekDeleteLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataPost),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + MSTTRAYEK_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(msttrayekDeleteLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(msttrayekDeleteSuccess(true, data));
      })
      .catch((err) => {
        dispatch(msttrayekDeleteError(true));
      });
  };
}
